module.exports = __webpack_public_path__ + "static/img/hm_banner.f246a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hm_banner.jpg
// module id = II0a
// module chunks = 5